var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"loader-container",style:(_vm.styleDiv)},[_c('div',{staticClass:"lds-spinner"},[_c('svg-loader',{attrs:{"fill":_vm.color}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }